import React from "react";
import { Modal as AntModal, Button, Space } from "antd";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Modal = styled(AntModal)`
  .ant-modal-title {
    font-size: 24px;
  }

  .ant-modal-header {
    margin-bottom: 16px;
  }

  .ant-modal-footer {
    display: none;
  }

  .ant-form {
    .ant-form-item:last-child {
      margin-bottom: 0;
    }
  }
`;

const Footer = styled(Space).attrs({
  size: "middle",
})`
  width: 100%;

  .ant-space-item {
    flex: 0.5;
  }

  .ant-btn {
    width: 100%;
    height: 56px;
  }
`;

const InfoText = styled.div`
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: 400;
  color: #1e1e1e;
`;

const ItemsWrapper = styled.div`
  margin-bottom: 24px;
`;

const ItemBox = styled.div`
  padding: 16px;
  display: flex;
  gap: 16px;
  border: 1px solid #b9b9b9;
  border-top: none;

  :first-child {
    border-top: 1px solid #b9b9b9;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
  }

  :last-child {
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
  }

  .ant-btn {
    height: 40px;
  }
`;

const BoldText = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: ${(props) => props.theme.primaryColor};
`;

const LightText = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #686868;
  padding-bottom: 16px;
  text-align: left;
`;
const UnlinkDomainModal = ({ open, onClose, onConfirm, domainName }) => {

  const {t} = useTranslation();

  return (
    <Modal
      centered
      width={560}
      open={open}
      onCancel={onClose}
      footer={false}
      title="Unlink Domain?"
    >
      <LightText>
       {t('unlink_domain')}{" "} <a href={domainName} target="_blank" rel="noopener noreferrer">
          {domainName}
        </a>? {t('by_continue')}
      </LightText>
      <Footer>
        <Button type="default" onClick={onClose}>
          {t('cancel')}
        </Button>
        <Button
          type="primary"
          danger
          onClick={() => {
            onConfirm();
            onClose();
          }}
        >
          {t('unlink')}
        </Button>
      </Footer>
    </Modal>
  );
};

export default UnlinkDomainModal;
